import React from 'react';
import { ButtonClean, ConfirmModal } from '@fourthwall/components';
import youTubeSettings from './assets/youtube-settings.png';
import * as S from './styled';
export const YouTubeStreamModal = ({ close }) => (React.createElement(ConfirmModal, { title: "Unlist your livestream", size: "medium", confirmLabel: "Continue to YouTube", text: React.createElement("div", null,
        "In order to keep your YouTube livestream exclusive to your members make sure you have it set to Unlisted. ",
        React.createElement(ButtonClean, { label: "Learn more", withUnderline: true, href: "/" }),
        React.createElement(S.Image, { src: youTubeSettings }),
        "Return to this page once you have your livestream link."), close: close }));
